'use strict';

angular.module('atex.art').filter('empty', function() {
  return function(value) {
    return !value || value.length === 0;
  };
});
